import axios from 'axios'

export default async function getNearPointInARange(position) {
  const response = await axios.post(import.meta.env.VITE_MOBILE_API + 'points/near', {
    lat: position.lat, // "-22.964952806537738"
    lng: position.lng, // "-43.17429542541504"
    range: 500
  })
  return response.data
}